import { CatalogProduct, StockItem, StockStatus } from '../models';

/** Classify a live catalog product as healthy / low / out. */
export function catalogStockStatus(p: CatalogProduct, lowThreshold: number): StockStatus {
  if (p.outOfStock || p.quantity === 0) return 'out';
  return p.quantity <= lowThreshold ? 'low' : 'ok';
}

/** Classify a shelf-stock row as healthy / low / out. */
export function stockItemStatus(item: StockItem, lowThreshold: number): StockStatus {
  if (item.isOutOfStock || item.quantity === 0) return 'out';
  return item.quantity <= lowThreshold ? 'low' : 'ok';
}
